module.exports = __webpack_public_path__ + "static/img/7d.d42d06e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7d.jpg
// module id = dKR3
// module chunks = 0